import { Pipe, PipeTransform } from '@angular/core';
import {
  ADMIN_ROLE,
  ORGANISATION_ADMIN_ROLE,
  COORDINATOR_ROLE,
  FAMILY_ROLE,
  hasStaffRole,
  hasFamilyRole,
  CARER_ROLE,
} from '@careapp-group/core';

@Pipe({
  name: 'displayroles',
  pure: true,
})
export class DisplayRolesPipe implements PipeTransform {
  transform(roles: Array<string>, author?: { permissions: Array<{ role: string }> }) {
    if (!roles) {
      if (!author) {
        return [];
      }
      const userRoleNames = author.permissions.map((role) => role.role);
      if (hasStaffRole(userRoleNames) && !hasFamilyRole(userRoleNames)) {
        return [COORDINATOR_ROLE, CARER_ROLE];
      } else {
        return [COORDINATOR_ROLE, FAMILY_ROLE];
      }
    }

    if (roles.includes(COORDINATOR_ROLE) && roles.includes(CARER_ROLE) && hasFamilyRole(roles)) {
      return ['EVERYONE'];
    }

    return roles.filter((role) => role !== ADMIN_ROLE && role !== ORGANISATION_ADMIN_ROLE);
  }
}
